import { render } from "./phone.vue?vue&type=template&id=342a112e&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import "./phone.vue?vue&type=style&index=0&id=342a112e&lang=scss&scoped=true"
import "./phone.vue?vue&type=style&index=1&id=342a112e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342a112e"]])

export default __exports__